<template>
    <div id="page" class="about-page closed-mobile-header">
        <a class="skip-link screen-reader-text" href="#content">Skip to content</a>
        <div class="menu-close-toggle hamburger-close-bg-enable hamburger-close-bg-hover-enable hamburger-close-border-enable hamburger-close-border-hover-enable">
            <div class="close-line-wrap"><span class="close-line"></span><span class="close-line"></span><span class="close-line"></span></div>
        </div>

        <div class="mobile-header-space"></div>

        <Header></Header>
        <div id="main" class="sidebar-none sidebar-divider-vertical" style="padding-top:0px;">
            <div class="main-gradient"></div>
            <div class="wf-wrap">
                <div class="wf-container-main">
                    <div id="content" class="content" role="main">
                        <div class="vc_row wpb_row vc_row-fluid vc_custom_1635445472096 vc_row-has-fill lazyloaded">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="vc_empty_space" style="height:70px;"><span
                                            class="vc_empty_space_inner"></span></div>
                                        <div class="wpb_text_column wpb_content_element  vc_custom_1551822133256">
                                            <div class="wpb_wrapper"><h1
                                                class="main-text btx-heading-text btx-secondary-font btx-s-text-color btx-s-text-border">
                                                <span class="font-style font-style-big" style="color:#fff;">Seamlessly integrated legal counsel to advise and grow with you.&nbsp;</span>
                                            </h1></div>
                                        </div>
                                        <div class="wpb_text_column wpb_content_element  vc_custom_1551822174384">
                                            <div class="wpb_wrapper"><h4
                                                class="additional-text btx-heading-text btx-primary-font btx-s-text-color btx-s-text-border">
                                                <span class="font-style" style="color:#fff;"><em>Brilliant legal protection for brilliant startups. Your success is ours.</em>&nbsp;</span>
                                            </h4></div>
                                        </div>
                                        <div class="vc_empty_space" style="height:70px;"><span
                                            class="vc_empty_space_inner"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="vc_empty_space" style="height:70px;"><span
                                            class="vc_empty_space_inner"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid vc_custom_1549199536460">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="wpb_text_column wpb_content_element ">
                                            <div class="wpb_wrapper"><h2><span class="font-style">We’ve Gotten To Know You. Now Get To Know Us.</span>
                                            </h2></div>
                                        </div>
                                        <div class="wpb_text_column wpb_content_element ">
                                            <div class="wpb_wrapper">
                                                <div class="btx-feature-item btx-p-border-border btx-col-12 with-image">
                                                    <div class="btx-feature-item-inner">
                                                        <div class="btx-feature-body">
                                                            <div class="btx-feature-description"><span
                                                                class="font-style">Starting a business should be&nbsp;<em>fun.&nbsp; </em>We want to make sure you don’t forget that. CLG was born as an auxiliary branch of a larger firm that has provided legal protection to some of the biggest technology companies in the universe.&nbsp; CLG has since been acquired by Cohn Legal, PLLC and our law firm has devoted its energies to servicing clients in New York, Massachusetts, and various cities and indeed countries throughout the world.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vc_empty_space" style="height:70px;"><span
                                            class="vc_empty_space_inner"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid vc_custom_1549201649279">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="wpb_text_column wpb_content_element ">
                                            <div class="wpb_wrapper">
                                                <div
                                                    class="btx-item js-item-heading btx-heading btx-heading--plain btx-left-align anmt-item anmt-fadein animated btx-opacity1">
                                                    <h3 class="btx-heading-text btx-primary-font btx-s-text-color btx-s-text-border">
                                                        <span class="font-style">The Firm’s Guiding Principle is Excellence.</span>
                                                    </h3></div>
                                                <div
                                                    class="btx-item js-item-text btx-text btx-left-align btx-primary-font">
                                                    <div class="btx-row">
                                                        <div class="btx-text-content btx-col-12">
                                                            <div class="btx-text-content-inner"><span
                                                                class="font-style">On the most fundamental level, our goal is to provide our clients with exceptional legal guidance and support at cost-effective rates. While excellence in legal representation is a given, we take greater pride in our ability to marshal new technologies to facilitate maximum connectivity with our clients and track our client’s cases with precision and care. We are continuously moving towards a fully digital legal interfacing process. Legal work can be complicated but it shouldn’t be unseemly.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_separator_no_text vc_sep_color_grey nitro-offscreen">
                                            <span class="vc_sep_holder vc_sep_holder_l"><span
                                                class="vc_sep_line"></span></span><span
                                            class="vc_sep_holder vc_sep_holder_r"><span
                                            class="vc_sep_line"></span></span></div>
                                        <div class="wpb_text_column wpb_content_element nitro-offscreen">
                                            <div class="wpb_wrapper">
                                                <div
                                                    class="btx-item js-item-heading btx-heading btx-heading--plain btx-left-align anmt-item anmt-fadein animated btx-opacity1">
                                                    <h3 class="btx-heading-text btx-primary-font btx-s-text-color btx-s-text-border">
                                                        <span class="font-style">No Surprise Bills. Ever.<br> </span>
                                                    </h3></div>
                                                <div
                                                    class="btx-item js-item-text btx-text btx-left-align btx-primary-font">
                                                    <div class="btx-row">
                                                        <div class="btx-text-content btx-col-12">
                                                            <div class="btx-text-content-inner"><span
                                                                class="font-style">The legal industry has gotten a bad rep for obscene hourly rates and “spontaneous” billing. We will never do that to you. During your initial onboarding with the firm, we will learn about your needs and craft a fully customer-built, case scope and budget. We take a hands on approach with our clients and understand deeply each client’s particular situation before beginning any work.&nbsp; &nbsp; &nbsp;</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_separator_no_text vc_sep_color_grey nitro-offscreen">
                                            <span class="vc_sep_holder vc_sep_holder_l"><span
                                                class="vc_sep_line"></span></span><span
                                            class="vc_sep_holder vc_sep_holder_r"><span
                                            class="vc_sep_line"></span></span></div>
                                        <div class="wpb_text_column wpb_content_element nitro-offscreen">
                                            <div class="wpb_wrapper">
                                                <div
                                                    class="btx-item js-item-heading btx-heading btx-heading--plain btx-left-align anmt-item anmt-fadein animated btx-opacity1">
                                                    <h3 class="btx-heading-text btx-primary-font btx-s-text-color btx-s-text-border">
                                                        <span class="font-style">Efficient and Seamless Integration<br> </span>
                                                    </h3></div>
                                                <div
                                                    class="btx-item js-item-text btx-text btx-left-align btx-primary-font">
                                                    <div class="btx-row">
                                                        <div class="btx-text-content btx-col-12">
                                                            <div class="btx-text-content-inner"><span
                                                                class="font-style">With experience comes confidence and know-how. We help our clients navigate through the murky waters of fast-paced deals and wordy, convoluted contracts <em>quickly</em>.&nbsp; We can jump into existing deals or help you start from day 1. Let’s discuss.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid nitro-offscreen">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="vc_empty_space" style="height:70px;"><span
                                            class="vc_empty_space_inner"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid nitro-offscreen">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper"></div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid nitro-offscreen">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="wpb_text_column wpb_content_element ">
                                            <div class="wpb_wrapper"><p>&nbsp;</p></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="International vc_row wpb_row vc_row-fluid nitro-offscreen nitro-lazy-render">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                                            <div class="wpb_wrapper"><a
                                                href="https://www.cohnlg.com/representative-clients/"
                                                class="action-link-wrap">
                                                <div class="action-img lazyloaded"></div>
                                                <div class="action-text"><h4>International</h4>
                                                    <p>A Global Practice working in Markets Beyond the United States
                                                        including Switzerland, Israel, Italy, Germany and other European
                                                        Countries</p> <small style="font-style:italic;color:white;">World-Wide
                                                        Protection</small></div>
                                            </a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="cp-load-after-post"></span>
                    </div>


                </div>
            </div>
        </div>

            <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Footer
    },
    mounted() {
        to_top()
    }
}
</script>
<style>
.about-page .top-line-space {
    height: 78px!important;
}
</style>
<style scoped>
p{

}
/*! CSS Used from: https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/optimized/rev-54e3c51/www.cohnlg.com/combinedCss/nitro-min-noimport-a05c35e8e6333693d7bd0777d3b0edec-stylesheet.css */
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-search:before{content:"ï€‚";}
.fa{font-family:Font Awesome\ 5 Free;}
.fa{font-weight:900;}
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-search:before{content:"ï€‚";}
.fa{font-family:"Font Awesome 5 Free";font-weight:900;}
.vc_row:after,.vc_row:before{content:" ";display:table;}
.vc_row:after{clear:both;}
.vc_column_container{width:100%;}
.vc_row{margin-left:-15px;margin-right:-15px;}
.vc_col-sm-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
@media (min-width:768px){
    .vc_col-sm-12{float:left;}
    .vc_col-sm-12{width:100%;}
}
#content .wpb_text_column :last-child,#content .wpb_text_column p:last-child,.wpb_text_column :last-child,.wpb_text_column p:last-child{margin-bottom:0;}
.wpb_content_element{margin-bottom:35px;}
.vc_column-inner::after,.vc_column-inner::before{content:" ";display:table;}
.vc_column-inner::after{clear:both;}
.vc_column_container{padding-left:0;padding-right:0;}
.vc_column_container>.vc_column-inner{box-sizing:border-box;padding-left:15px;padding-right:15px;width:100%;}
.vc_row-has-fill+.vc_row>.vc_column_container>.vc_column-inner,.vc_row-has-fill>.vc_column_container>.vc_column-inner{padding-top:35px;}
.vc_separator{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;}
.vc_separator .vc_sep_holder{height:1px;position:relative;-webkit-box-flex:1;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;min-width:10%;}
.vc_separator .vc_sep_holder .vc_sep_line{height:1px;border-top:1px solid #ebebeb;display:block;position:relative;top:1px;width:100%;}
.vc_separator.vc_separator_no_text:not(.vc_sep_shadow) .vc_sep_holder_l{width:100%;}
.vc_separator.vc_separator_no_text:not(.vc_sep_shadow) .vc_sep_holder_r{display:none;}
.vc_separator.vc_sep_color_grey .vc_sep_line{border-color:#ebebeb;}
.vc_sep_width_100{width:100%;}
.vc_sep_pos_align_center{margin-left:auto;margin-right:auto;}
*{padding:0;margin:0;}
a:active,a:focus,a:hover{outline:0;}
form{margin:0;}
input{font-size:100%;margin:0;vertical-align:baseline;}
input{line-height:normal;}
#main{-ms-grid-column:1;-ms-grid-row:5;grid-area:main;}
.content,.wf-wrap,.wpb_row{box-sizing:border-box;}
.wf-wrap{max-width:100%;padding:0 44px;margin:0 auto;}
.sidebar-none .content{width:100%;}
h1,h2,h3,h4{margin-bottom:10px;clear:both;}
a:hover{text-decoration:none;}
p{margin-bottom:10px;}
a{text-decoration:underline;}
.vc_empty_space{clear:both;}
.main-gradient{display:none;}
#main{padding:50px 0;}
input[type=text]:not(.elementor-field):not(.searchform-s){margin-bottom:10px;border-style:solid;box-sizing:border-box;}
input[type=text]{-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;outline:0;}
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-search:before{content:"ï€‚";}
.fa{font-family:"Font Awesome 5 Free";}
.fa{font-weight:900;}
#page .fa{font-family:"Font Awesome 5 Free";font-weight:900;}
#page .fa:before{font-weight:inherit;}
.content h1,.content h2,.content h3,.content h4{clear:none;}
#main .wf-wrap{padding:0 50px 0 50px;}
h1{color:#333;font:normal 600 60px/66px "Arial",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
@media (max-width: 1050px){
    h1{font-size:42px;}
}
@media (max-width: 778px){
    h1{font-size:42px;}
}
h2{color:#333;font:normal 600 42px/48px "Arial",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h3{color:#333;font:normal 700 24px/34px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h4{color:#333;font:normal 500 20px/30px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h1,h2,h3,h4{color:#333;}
a,a:hover{color:#1ebbf0;}
#main > .wf-wrap{width:1300px;}
#main{padding:70px 0 70px 0;}
#main > .wf-wrap{padding:0 50px 0 50px;}
input[type="text"]{color:#8b8d94;border-top-width:1px;border-right-width:1px;border-bottom-width:1px;border-left-width:1px;padding:5px 15px 5px 15px;border-color:rgba(51,51,51,.12);background-color:#fdfdfd;border-radius:1px;}
.content input[type="text"]{font-size:14px;line-height:25px;}
input[type="text"]{height:38px;}
input[type="text"]{font:normal 14px/25px "Lato",Helvetica,Arial,Verdana,sans-serif;font-size:14px;}
@media screen and (max-width: 778px){
    #main{padding:70px 0 70px 0;}
    #main > .wf-wrap{padding:0 20px 0 20px;}
}
@media screen and (min-width: 990px){
    #main > .wf-wrap{position:relative;}
    .content{grid-area:content;-ms-grid-row:1;}
}
/*! CSS Used from: Embedded */
.pattern{width:90%;padding:30px 0 0 0;background-color:transparent;background-repeat:repeat-x;background-image:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/images/optimized/rev-54e3c51/www.cohnpatents.com/wp-content/uploads/rand/pattern.svg");height:200px;display:flex;justify-content:flex-end;}
.pattern .box{height:200px;width:95%;max-width:1024px;padding:0 20px;background:#00c1cf;transform:translateX(5%);display:flex;align-items:flex-start;justify-content:center;flex-direction:column;}
.pattern .box *{color:white!important;}
.pattern .box h3{padding:0 20px;font-size:2em;}
#USPTO form{display:flex;max-width:900px;width:100%;justify-content:space-evenly;align-items:center;}
.search-input-wrap{width:70%;position:relative;}
.search-input-wrap i{position:absolute;font-size:22px;top:calc(50% - 11px);left:25px;color:#9b9b9b;}
#USPTO form input[type="text"]{width:100%;padding-left:80px;margin:0;border:1px solid white;height:67px;font-size:1.25em;background:transparent;}
.submit-btn{width:25%;height:67px;background:transparent;border-radius:0;border-width:0px;border-style:solid;border-color:black;transition:.5s;position:relative;}
#USPTO form .fake-submit{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;z-index:2;height:100%;width:100%;color:white;background:transparent;border:0px solid black;border-radius:0;transition:.5s;font-size:1em;}
#USPTO form .fake-submit:hover{background:orange!important;color:white;}
.submit-left,.submit-right{z-index:1;position:absolute;top:0;background-color:transparent;height:calc(100% - 4px);width:20px;border-bottom:2px solid orange;border-top:2px solid orange;}
.submit-left{border-left:2px solid orange;left:0;}
.submit-right{border-right:2px solid orange;right:0;}
#USPTO form input[type="text"]::placeholder{color:#dfdfdf!important;opacity:1;}
@media only screen and (max-width: 768px){
    .pattern .box h3{font-size:1.2em;}
    #USPTO form{flex-direction:column;}
    .search-input-wrap{width:100%;}
    .submit-btn{width:100%;margin-top:10px;}
    .pattern .box{height:300px;}
}
/*! CSS Used from: Embedded */
.vc_custom_1635445472096{background-image:url("../../public/images/about-bg.jpg")!important;background-position:center!important;background-repeat:no-repeat!important;background-size:cover!important;}
.vc_custom_1549199536460{padding-right:30px!important;padding-left:30px!important;}
.vc_custom_1549201649279{padding-right:30px!important;padding-left:30px!important;}
.vc_custom_1579127537744{padding-top:0px!important;padding-bottom:80px!important;}
.vc_custom_1551822133256{padding-left:30px!important;}
.vc_custom_1551822174384{padding-left:30px!important;}
.vc_custom_1572271494934{margin-top:40px!important;}
/*! CSS Used from: Embedded */
#main > .wf-wrap{width:1480px;}
input[type="text"]{border-top:none;border-right:none;border-left:none;background-color:#fff;border-width:2px;border-color:#222;}
#page input[type="text"]{font-size:15px;font-height:18px;}
input[type="text"]{color:#333;font-size:15px;}
input[type="text"]{font:normal 300 16px/20px "Nunito",Helvetica,Arial,Verdana,sans-serif;}
input[type="text"]{color:#222;}
.box{transition:box-shadow .3s;width:100%;height:100%;margin:0px;background:#fff;float:center!important;}
.box:hover{box-shadow:0 0 25px rgba(33,33,33,.2);opacity:1;}
a{text-decoration:none!important;}
h1{letter-spacing:8px;}
/*! CSS Used from: Embedded */
#main{padding-top:0px;}
@media screen and (max-width: 778px){
    #main{padding-top:0px;}
}
.main-text {
    font-size: 59px!important;
    line-height: 66px!important;
}
.additional-text {}

/*! CSS Used fontfaces */
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:400;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-regular-400.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:900;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-solid-900.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:400;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-regular-400.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:900;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-solid-900.woff2") format("woff2");font-display:swap;}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-54e3c51/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}

h1.main-text {
    font-size: 60px!important;
    font: normal 600 60px/66px "Arial",Helvetica,Arial,Verdana,sans-serif;
}
h2 {
    font-size: 42px!important;
    font-weight: 600!important;
    letter-spacing: 0;
}
h4 {

}
div>span.font-style {
    font: normal 19px/27px "Lato",Helvetica,Arial,Verdana,sans-serif;
    word-spacing: normal;
    color: #505c62;
}

/*! CSS Used from: https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/optimized/rev-54e3c51/www.cohnlg.com/combinedCss/nitro-min-noimport-893919e6b4ec6657ecfb378fc794c564-stylesheet.css */
.vc_row:after,.vc_row:before{content:" ";display:table;}
.vc_row:after{clear:both;}
.vc_column_container{width:100%;}
.vc_row{margin-left:-15px;margin-right:-15px;}
.vc_col-sm-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
@media (min-width:768px){
    .vc_col-sm-12{float:left;}
    .vc_col-sm-12{width:100%;}
}
.wpb_content_element{margin-bottom:35px;}
.vc_column-inner::after,.vc_column-inner::before{content:" ";display:table;}
.vc_column-inner::after{clear:both;}
.vc_column_container{padding-left:0;padding-right:0;}
.vc_column_container>.vc_column-inner{box-sizing:border-box;padding-left:15px;padding-right:15px;width:100%;}
*{padding:0;margin:0;}
a:active,a:focus,a:hover{outline:0;}
small{font-size:75%;}
.wpb_row{box-sizing:border-box;}
h4{margin-bottom:10px;clear:both;}
a:hover{text-decoration:none;}
p{margin-bottom:10px;}
a{text-decoration:underline;}
.content h4{clear:none;}
h4{color:#333;font:normal 500 20px/30px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h4{color:#333;}
a,a:hover{color:#1ebbf0;}
.vc_row,.wpb_column,.wpb_row{position:relative;}
/*! CSS Used from: Embedded */
.action-link-wrap{position:relative;display:block;min-height:300px;overflow:hidden;}
.action-link-wrap .action-img{position:absolute;top:0;left:0;background:url("../../public/images/sec-ac-bg2.jpg") no-repeat top center;background-size:cover;width:100%;height:100%;transition:transform 1s;}
.action-link-wrap .action-img:after{background-color:rgba(0,0,0,.2);bottom:0;content:"";display:block;transition:background-color 1s;width:100%;height:100%;position:absolute;}
.action-link-wrap:hover .action-img{transform:scale(1.05);}
.action-link-wrap .action-text{position:relative;padding:30px;}
.action-text h4,.action-text p{color:white;}
.action-text h4{text-transform:uppercase;letter-spacing:3px;font-size:1.2em;}
.action-text p{max-width:620px;font-size:1.5em;line-height:1.2em;}
/*! CSS Used from: Embedded */
a{text-decoration:none!important;}
/*! CSS Used from: Embedded */
.nitro-lazy-render{content-visibility:auto;contain-intrinsic-size:1000px;}
.International p {
    display: block;
}
.International h4 {
    font-size: 23px;
}
.International p {
    font-family: "Lato",Helvetica,Arial,Verdana,sans-serif;
    font-size: 29px;
}
.International h4 {}
</style>

